import { render, staticRenderFns } from "./class-dashboard-v2.vue?vue&type=template&id=d09f775e&scoped=true&"
import script from "./class-dashboard-v2.vue?vue&type=script&lang=js&"
export * from "./class-dashboard-v2.vue?vue&type=script&lang=js&"
import style0 from "./class-dashboard-v2.vue?vue&type=style&index=0&id=d09f775e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09f775e",
  null
  
)

export default component.exports